interface IProps {}

/**
 * @deprecated
 *
 * We will remove this component in future versions.
 *
 * In future we will rename it & use in better way
 *
 *
 */
const ComingSoon: React.FC<IProps> = ({}: IProps) => {
  return <h1>Coming Soon</h1>;
};

export default ComingSoon;
